export enum CfmProductAddressTypeModel {
  StartAddresses = "startAddresses",
  TargetAddresses = "targetAddresses",
}
